"use client";

import { FileQuestion } from "lucide-react";
import { useTranslation } from "react-i18next";
import { ErrorPageLayout } from "./components/ErrorPageLayout";

export function NotFoundPage() {
  const { t } = useTranslation("common");

  return (
    <ErrorPageLayout
      code="404"
      title={t("errors.notFound.title")}
      description={t("errors.notFound.description")}
      icon={FileQuestion}
      showGoBack={true}
      backHomeLabel={t("errors.notFound.backHome")}
      goBackLabel={t("errors.generic.goBack")}
    />
  );
}

export default NotFoundPage;
